const taskMap = new Map();
let counter = 0;

export const registerModalTask = (fn) => {
  const id = `modalTask_${Date.now()}_${counter++}`;
  taskMap.set(id, fn);
  return id;
};

export const resolveModalTask = (id) => taskMap.get(id);

export const clearModalTask = (id) => {
  taskMap.delete(id);
};

export const clearAllModalTasks = () => {
  taskMap.clear();
};
